import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[workUiConfirmActionModalHost]',
  standalone: true,
})
export class ConfirmActionModalHostDirective {
  viewContainerRef = inject(ViewContainerRef);
}
